import type { EReportPresetKey } from '../../types';

import { REPORT_DATA_PRESET, REPORT_UI_PRESET } from '../../presets';
import { buildPresetForCampaign } from './preset-campaign';
import { buildPresetForPage } from './preset-page';
import { EReportSource } from '../../types';

export type ReportCampaignParamsType = {
  campaignId: string | null;
  campaignType: string | null;
  campaignGroupId: string | null;
};
export function buildPreset(data: {
  from: EReportSource;
  presetKey: EReportPresetKey;
  locationPath: string | null;
  campaign: ReportCampaignParamsType;
}) {
  const { from, presetKey, locationPath, campaign } = data;
  const preset = {
    presetData: REPORT_DATA_PRESET[presetKey],
    presetUI: REPORT_UI_PRESET[presetKey],
  };

  switch (from) {
    case EReportSource.CAMPAIGN:
      return buildPresetForCampaign(preset, campaign, presetKey);
    case EReportSource.PAGE:
      return buildPresetForPage(preset, locationPath);
    default:
      return preset;
  }
}
